import { GlSkeletonLoader } from '@gitlab/ui';
export default {
    name: 'TagsLoader',
    components: {
        GlSkeletonLoader
    },
    loader: {
        repeat: 10,
        width: 1000,
        height: 40
    }
};
